import { useParams } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'
import { useGetMeetingPreparationTasks } from '../../services/api/meeting-preparation-tasks.hooks'
import { useGetTasksV4 } from '../../services/api/tasks.hooks'
import { icons } from '../../styles/images'
import { Motion } from '../../styles/motion'
import EmptyDetails from '../details/EmptyDetails'
import TaskDetails from '../details/TaskDetails'
import useOverviewLists from './useOverviewLists'

const detailIn = keyframes`
    from { opacity: 0; transform: translateX(${Motion.overlayOffset}); }
    to { opacity: 1; transform: translateX(0); }
`
const DetailEntrance = styled.div`
    min-width: 0;
    flex: 1;
    display: flex;
    overflow: hidden;
    animation: ${detailIn} ${Motion.enter};

    > * {
        flex: 1;
    }
`

export const useOverviewDetailState = () => {
    const { lists, isLoading, flattenedLists } = useOverviewLists()
    const { overviewViewId, overviewItemId, subtaskId } = useParams()
    const selectedList = lists?.find((list) => list.id === overviewViewId)
    const { data: allTasks, isLoading: isGetAllTasksLoading } = useGetTasksV4()
    const { data: meetingPreparationTasks, isLoading: isMeetingPreparationTasksLoading } =
        useGetMeetingPreparationTasks()
    const selectedTaskId = subtaskId || overviewItemId
    const selectedTask =
        selectedList?.type === 'meeting_preparation'
            ? meetingPreparationTasks?.find((task) => task.id === selectedTaskId)
            : selectedList
            ? allTasks?.find((task) => task.id === selectedTaskId)
            : undefined

    return {
        lists,
        flattenedLists,
        selectedList,
        selectedTask,
        meetingPreparationTasks,
        hasSelectedOverviewDetail: Boolean(selectedTask),
        isLoading: isLoading || isGetAllTasksLoading || isMeetingPreparationTasksLoading,
    }
}

const OverviewDetails = () => {
    const { lists, isLoading, flattenedLists, selectedList, selectedTask } = useOverviewDetailState()

    if (isLoading) return null
    else if (lists.length > 0 && flattenedLists.length === 0)
        return (
            <DetailEntrance>
                <EmptyDetails icon={icons.check} text="Your lists are all empty" />
            </DetailEntrance>
        )
    else if (lists.length === 0)
        return (
            <DetailEntrance>
                <EmptyDetails icon={icons.list} text="You have no lists" />
            </DetailEntrance>
        )
    else if (!selectedList) {
        return null
    } else if (!selectedTask) return null
    return (
        <DetailEntrance key={selectedTask.id} data-overview-detail-id={selectedTask.id}>
            <TaskDetails task={selectedTask} />
        </DetailEntrance>
    )
}

export default OverviewDetails
